//Reset data
export const RESET = "DIVISION_DEL_RESET"



//Loading
export const SET_TOGGLE_LOADING = "DIVISION_DEL_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "DIVISION_DEL_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "DIVISION_DEL_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "DIVISION_DEL_SET_MESSAGE"
export const SET_IS_SUCCESS = "DIVISION_DEL_SET_IS_SUCCESS"
export const SET_IS_ERROR = "DIVISION_DEL_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "DIVISION_DEL_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "DIVISION_DEL_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "DIVISION_DEL_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "DIVISION_DEL_SET_ITEMS"
export const SET_CURRENT_ITEM = "DIVISION_DEL_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "DIVISION_DEL_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "DIVISION_DEL_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "DIVISION_DEL_SET_HIDE_MODAL"


export const SET_MODAL = "DIVISION_DEL_SET_MODAL"
export const SET_MODAL_CONTENT = "DIVISION_DEL_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "DIVISION_DEL_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "DIVISION_DEL_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "DIVISION_DEL_SET_MODAL_TYPE"
export const SET_MODAL_IS_UPDATE = "DIVISION_DEL_SET_IS_UPDATE"